import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-white p-4 text-center fixed bottom-0 w-full">
      <p>
        Developed By <strong className="font-bold">Dev Varshney</strong>❤️
      </p>
    </footer>
  );
};

export default Footer;
